import * as React from 'react';

function ContactIcon(props) {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width={16} height={16} viewBox='0 0 16 16' fill='none' {...props}>
			<path
				d='M10.667 1.333v1.334m-6 12v-1.334A1.333 1.333 0 016 12h4a1.333 1.333 0 011.333 1.333v1.334m-6-13.334v1.334M10 7.333a2 2 0 11-4 0 2 2 0 014 0zM3.333 2.667h9.334C13.403 2.667 14 3.264 14 4v9.333c0 .737-.597 1.334-1.333 1.334H3.333A1.333 1.333 0 012 13.333V4c0-.736.597-1.333 1.333-1.333z'
				stroke='#545454'
				strokeWidth={1.33333}
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
}

export default ContactIcon;
